import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationType } from '@app/shared/interfaces';
import { QuestionService } from '@app/shared/services/questions/question.service';
import { RuleService } from '@app/shared/services/rule/rule.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { DialogDeleteRulesetComponent } from '../../components/dialog-delete-ruleset/dialog-delete-ruleset.component';

@Component({
  standalone: false,
  selector: 'sbnb-question-detail',
  templateUrl: './question-detail.component.html',
  styleUrls: ['./question-detail.component.scss'],
})
export class QuestionDetailComponent implements OnInit {
  editModeQuestionName: boolean;
  intentId: string;
  loading: boolean;
  intentData: any;
  rulesetsData: any;
  testString: string;
  lastDetectResults: any;
  detectInProgress: boolean;
  examplesShown = 5;
  saveStatus: number;

  constructor(
    private location: Location,
    private questionService: QuestionService,
    private route: ActivatedRoute,
    private titleService: TitleService,
    private router: Router,
    private ruleService: RuleService,
    private toast: ToastNotificationsService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loading = true;
    this.titleService.manuallySet('Question');

    this.route.params.subscribe((params) => {
      this.intentId = params['id'];
      this.questionService.getIntent(this.intentId).subscribe((res) => {
        this.intentData = res.data;
        this.rulesetsData = res.meta?.rulesets;
        this.loading = false;

        if (this.intentData.is_custom) {
          this.intentData.examples.push(null);
        }

        this.titleService.manuallySet(this.intentData.name);
      });
    });
  }

  goBack() {
    this.router.navigate(['/gx/questions']);
  }

  deleteRulesetPrompt() {
    const dialogRef = this.dialog.open(DialogDeleteRulesetComponent, {
      width: '720px',
      data: {
        item: 'intent',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteIntent();
      }
    });
  }

  deleteIntent() {
    this.questionService.deleteIntent(this.intentId).subscribe((res) => {
      this.location.back();
    });
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  addAnotherSample() {
    this.intentData.examples.splice(this.examplesShown, 0, null);
    this.examplesShown += 1;
  }

  exampleBlur() {
    const updatedExamples = [];

    this.intentData.examples.forEach((ex, index) => {
      if (ex === null || ex === '') {
      } else {
        updatedExamples.push(ex);
      }
    });

    this.saveStatus = 1;
    this.questionService.updateIntent(this.intentId, updatedExamples).subscribe((res) => {
      if (res.error) {
        this.saveStatus = -1;
      }

      this.saveStatus = 2;
      setTimeout(() => {
        this.saveStatus = null;
      }, 2000);
    });
  }

  detect() {
    this.detectInProgress = true;
    this.questionService.runDetection(this.testString).subscribe((res) => {
      this.lastDetectResults = res;
      if (!this.lastDetectResults) {
        this.lastDetectResults = [];
      }
      this.detectInProgress = false;
    });
  }

  openRuleset(rule) {
    this.router.navigate(['/gx/rule', rule.id]);
  }

  activateOrDeactivateRule(rule, event: MatCheckboxChange) {
    rule.active = event.checked;
    this.saveStatus = 1;

    this.ruleService.activeOrDeactivateRuleset(rule.id, rule.active).subscribe((res: any) => {
      if (res.success) {
        this.saveStatus = 2;
        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
        return;
      }

      if (res.error) {
        this.saveStatus = -1;
        rule.active = !rule.active;

        this.toast.open(`Oops! We ran into an error updating the rule`, 'Dismiss', NotificationType.Error);
      }
    });
  }

  createQuestionRule(intent: any) {
    const payload = {
      name: `Reply to questions about ${intent.name}`,
      event: `question:${intent.intent}`,
      all_platforms: true,
      all_hosts: true,
      all_properties: true,
      mode: 'passive',
    };

    this.ruleService.createRuleset(payload).subscribe((res) => {
      if (res.data.id) {
        this.router.navigate(['/gx/rule', res.data.id]);
      }
    });
  }
}
